export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4768.c60e3497.jpg";